import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface contactUsState {
	isLoading: boolean;
	notificationList: any;
	totalNotification: number;
	selectedNotificationState: any;
	unreadCount: number;
}

const initialState: contactUsState = {
	isLoading: false,
	notificationList: [],
	totalNotification: 0,
	selectedNotificationState: [],
	unreadCount: 0
};

const notificationSlice = createSlice({
	name: 'notification',
	initialState,
	reducers: {
		getNotificationListInit: state => {
			state.isLoading = true;
			state.notificationList = [];
			state.totalNotification = 0;
		},
		getnotificationListSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			const data = action.payload.data;
			state.notificationList = [...data.notifications];
			state.totalNotification = data.count;
			state.unreadCount = data.unreadNotificationCount;
		},
		getnotificationListError: state => {
			state.isLoading = false;
			state.totalNotification = 0;
			state.notificationList = [];
		},
		setSelectedNotifications: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			state.selectedNotificationState = action.payload;
		},
		clearSelectedNotification: state => {
			state.selectedNotificationState = [];
		}
	}
});
export const {
	getnotificationListSuccess,
	getnotificationListError,
	getNotificationListInit,
	setSelectedNotifications,
	clearSelectedNotification
} = notificationSlice.actions;

export default notificationSlice.reducer;
